var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',_vm._b({attrs:{"contain":"","src":require(`@/assets/icons/${_vm.icon}.svg`)}},'v-img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }